import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledWalletSectionUxlError = styled.div`
  width: 100%;

  .m-message-content {
    font-weight: ${baseVariables.font.fontWeightRegular};

    strong,
    b {
      font-weight: ${baseVariables.font.fontWeightMedium};
    }
  }
`;
